<p-tabView (onChange)="onTabChange($event)" [ngClass]="{'gltab': visibleFromModule != 'Finance'}">
    <p-tabPanel header="Overview">
        <div class="card">
            <div class="p-grid">
                <div class="p-col-2">
                    <p><strong>Location: </strong></p>
                    <p><strong>Adjustment Date: </strong></p>
                    <p><strong>Posting Period: </strong></p>
                </div>
                <div class="p-col-4">
                    <p>{{adjustmentDetail?.warehouseName }}</p>
                    <p>{{adjustmentDetail?.adjustmentDate | date: 'MM/dd/yyyy'}}</p>
                    <p>{{adjustmentDetail?.postingDate ? (adjustmentDetail?.postingDate | date: 'MMMM yyyy') : null}}</p>
                </div>
                <div class="p-col-2">
                    <p><strong>Adjustment No.: </strong></p>
                    <p><strong>Adjustment Type: </strong></p>
                    <p><strong>Adjustment Account: </strong></p>
                </div>
                <div class="p-col-4">
                    <!-- <p>{{adjustmentDetail?.adjustmentType}}</p> -->
                    <p>{{adjustmentDetail?.number}}</p>
                    <p>{{'Quantity'}}</p> <!-- TODO .. -->
                    <p>{{adjustmentDetail?.financialAccountName}}</p>
                </div>
            </div>
            <div class="p-grid">
                <div class="p-col-12">
                    <p-table [value]="adjustmentDetail?.inventoryAdjustmentDetail">
                        <ng-template pTemplate="header">
                            <tr>
                                <th>Product Name</th>
                                <th>Bin</th>
                                <th>QOH</th>
                                <th>New Qty</th>
                                <th>Qty Difference</th>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="body" let-adjust>
                            <tr>
                                <td>{{adjust.productName }}</td>
                                <td>{{adjust.binName}}</td>
                                <td>{{adjust.totalCurrentStock | customNumberFormat: qtyDecimal }}</td>
                                <td>{{adjust.totalNewStock | customNumberFormat: qtyDecimal}}</td>
                                <td>{{adjust.totalQtyChange | customNumberFormat: qtyDecimal}}</td>
                            </tr>
                        </ng-template>
                    </p-table>
                </div>
            </div>
            <div class="p-grid">
                <div class="p-col-2">
                    <p><strong>Comments: </strong></p>
                </div>
                <div class="p-col-10">
                    <p>{{adjustmentDetail?.comment}}--({{adjustmentDetail?.createdByUser}}-{{adjustmentDetail?.createdDate | date: 'MM/dd/yyyy'}})</p>
                </div>
            </div>
        </div>
        <p-toast position="top-right" [baseZIndex]="10000"></p-toast>
    </p-tabPanel>
    <p-tabPanel header="Impacts on G/L">
        <app-inventory-impacts-gl [selectedId]="inventoryAdjustmentId" [objectTypeId]="transactionTypeIds.InventoryAdjustment" [callApi]="glApiCall"></app-inventory-impacts-gl>
    </p-tabPanel>
</p-tabView>